import { all, put, select, retry, call } from 'redux-saga/effects';
import { reject, resolve } from '../api';
import history from '../history';
import * as types from '../constants';
import { anonClient, authClient } from '../api/Client';
import { loadFilterProfiles, loadFilters } from '../actions/filters';
import {
  loadUser,
  loadOrganization,
  loadMySubscriptionPlan,
} from '../actions/user';
import { get2faConfirmationToken } from '../selectors/auth';
import { NOTIFICATION } from '../constants';
import {
  errorNotification,
  showNotification,
  successNotification,
} from '../../shared-components/Notifications';
import Cookies from 'cookies-js';

export function* login({ data }) {
  try {
    const response = yield call(anonClient?.Auth?.login, {
      body: data,
      headers: { 'x-app-origin': process.env.REACT_APP_FRONTEND_NODE_ENV },
    });
    const payload = response?.data();

    yield put({
      type: resolve(types.LOGIN),
      payload,
    });

    if (!payload?.redirect_to) {
      if (!payload?.has_2fa_enabled) {
        // yield put(loadFilterProfiles());
        // yield put(loadFilters());
        // yield retry(4, 500, loadUser());
        // yield retry(4, 500, loadMySubscriptionPlan());
        yield put(loadUser());
        yield put(loadMySubscriptionPlan());
        // yield put(loadOrganization());
        const nextURL = new URLSearchParams(window.location.search);
        let redirectTo = '/explore';
        if (nextURL.get('next')) {
          redirectTo = decodeURIComponent(nextURL.get('next'));
        }
        history.push(redirectTo);
      }
    }
  } catch (error) {
    yield all([
      put({
        type: reject(types.LOGIN),
        error,
      }),
      put({
        type: NOTIFICATION.ADD_NOTIFICATION,
        notification: errorNotification(error, reject(types.LOGIN)),
      }),
    ]);
  }
}

export function* impersonate({ data }) {
  try {
    const response = yield call(authClient?.Auth?.impersonate, {
      body: data,
    });

    const payload = response?.data();

    yield put({
      type: resolve(types.IMPERSONATE),
      payload,
    });

    yield put(loadFilterProfiles());
    yield put(loadFilters());
    yield put(loadUser());
    yield put(loadOrganization());
    const nextURL = new URLSearchParams(window.location.search);
    let redirectTo = '/explore';
    if (nextURL.get('next')) {
      redirectTo = decodeURIComponent(nextURL.get('next'));
    }
    history.push(redirectTo);
  } catch (error) {
    yield all([
      put({
        type: reject(types.IMPERSONATE),
        error,
      }),
      put({
        type: NOTIFICATION.ADD_NOTIFICATION,
        notification: errorNotification(error, reject(types.LOGIN)),
      }),
    ]);
  }
}

export function* checkToken({ data }) {
  try {
    const response = yield retry(4, 500, anonClient?.Auth?.checkToken, {
      body: data,
    });

    const payload = response?.data();

    yield put({
      type: resolve(types.CHECK_TOKEN),
      payload,
    });
  } catch (error) {
    // const jsonError = JSON.parse(error.responseData);
    // console.log('jsonError["errors"]["message"]', jsonError["errors"]["message"]);
    yield all([
      put({
        type: reject(types.CHECK_TOKEN),
        error,
      }),
      // put({
      //   type: NOTIFICATION.ADD_NOTIFICATION,
      //   notification: errorNotification(error, reject(types.CHECK_TOKEN)),
      // }),
    ]);
  }
}

export function* refreshAccessToken({ data }) {
  try {
    const response = yield retry(4, 500, anonClient?.Auth?.refreshToken, {
      body: data,
    });

    const payload = response?.data();

    yield put({
      type: resolve(types.REFRESH_TOKEN),
      payload,
    });

    if (!payload?.has_2fa_enabled) {
      //yield put(loadFilterProfiles());
      //yield put(loadFilters());
      //yield put(loadUser());
      //history.push('/');
    }
  } catch (error) {
    yield all([
      put({
        type: reject(types.REFRESH_TOKEN),
        error,
      }),
      put({
        type: NOTIFICATION.ADD_NOTIFICATION,
        notification: errorNotification(error, reject(types.REFRESH_TOKEN)),
      }),
    ]);
  }
}

export function* register({ data }) {
  try {
    yield retry(4, 500, anonClient?.Auth?.register, {
      body: data,
    });

    yield put({
      type: resolve(types.REGISTER),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types.REGISTER),
        error,
      }),
      put({
        type: NOTIFICATION.ADD_NOTIFICATION,
        notification: errorNotification(error, reject(types.REGISTER)),
      }),
    ]);
  }
}

export function* resetPassword({ data }) {
  try {
    yield retry(4, 500, anonClient?.Auth?.resetPassword, {
      body: data,
    });

    yield put({
      type: resolve(types.RESET_PASSWORD),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types.RESET_PASSWORD),
        error,
      }),
      put({
        type: NOTIFICATION.ADD_NOTIFICATION,
        notification: errorNotification(error, reject(types.RESET_PASSWORD)),
      }),
    ]);
  }
}

export function* validateEmailOnRegister({ email }) {
  try {
    yield retry(0, 500, anonClient?.Accounts?.validateEmail, {
      body: { email: email },
    });
    // yield retry(4, 500, anonClient?.Auth?.confirmPasswordReset, {
    //   body: data,
    // });
    yield put({
      type: resolve(types.VALIDATE_EMAIL_ON_REGISTER),
    });
  } catch (error) {
    const json_error = JSON?.parse(error?.responseData);
    yield all([
      put({
        type: reject(types.VALIDATE_EMAIL_ON_REGISTER),
        errorMessages: json_error?.['email'] || error,
      }),
      // put({
      //   type: NOTIFICATION?.ADD_NOTIFICATION,
      //   notification: errorNotification(
      //     json_error['email'] || error,
      //     reject(types.VALIDATE_EMAIL_ON_REGISTER),
      //   ),
      // }),
    ]);
  }
}

export function* confirmPasswordReset({ data }) {
  try {
    yield retry(0, 500, anonClient?.Accounts?.validatePassword, {
      body: { password: data['new_password'] },
    });
    if (
      ['explore', 'dev-explore']?.includes(
        process.env.REACT_APP_FRONTEND_NODE_ENV,
      )
    ) {
      yield retry(4, 500, anonClient?.Auth?.confirmCommunityPasswordReset, {
        body: data,
      });
    } else {
      yield retry(4, 500, anonClient?.Auth?.confirmPasswordReset, {
        body: data,
      });
    }
    yield put({
      type: resolve(types.CONFIRM_PASSWORD_RESET),
    });
    // showNotification(
    //   successNotification({
    //     statusCode: 200,
    //     message: 'Password set successfully. Login with your new credentials.',
    //   }),
    // );
  } catch (error) {
    const json_error = JSON.parse(error?.responseData);
    yield all([
      put({
        type: reject(types.CONFIRM_PASSWORD_RESET),
        errorMessages: json_error['password'][0] || error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          json_error['password'][0] || error,
          reject(types.CONFIRM_PASSWORD_RESET),
        ),
      }),
    ]);
  }
}

export function* enable2fa({ pin }) {
  try {
    const res = yield retry(4, 500, authClient?.Auth?.enable2fa, {
      body: {
        pin,
      },
    });
    const payload = res?.data();
    if (payload?.verification?.success) {
      yield put({
        type: resolve(types.ENABLE_2FA),
        payload: res?.data(),
      });
    } else {
      yield put({
        type: reject(types?.ENABLE_2FA),
        error: payload?.verification?.message,
      });
    }
    showNotification(
      successNotification({
        statusCode: 200,
        message: '2FA enabled',
      }),
    );
  } catch (error) {
    yield all([
      put({
        type: reject(types?.ENABLE_2FA),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(error, reject(types.ENABLE_2FA)),
      }),
    ]);
  }
}

export function* loginWith2fa({ data }) {
  try {
    const token = yield select(get2faConfirmationToken);
    const response = yield retry(4, 500, anonClient?.Auth?.loginWith2fa, {
      body: { ...data, token },
    });

    yield put({
      type: resolve(types.LOGIN_WITH_2FA),
      payload: response?.data(),
    });

    // yield put(loadFilterProfiles());
    // yield put(loadFilters());
    yield put(loadUser());
    yield put(loadMySubscriptionPlan());
    // yield put(loadOrganization());

    history.push('/explore');
  } catch (error) {
    yield all([
      put({
        type: reject(types.LOGIN_WITH_2FA),
        error,
      }),
      put({
        type: NOTIFICATION.ADD_NOTIFICATION,
        notification: errorNotification(error, reject(types.LOGIN_WITH_2FA)),
      }),
    ]);
  }
}

export function* load2faQR() {
  try {
    const res = yield retry(4, 500, authClient?.Auth?.load2faQR);
    yield put({
      type: resolve(types.LOAD_2FA_QR),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types.LOAD_2FA_QR),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(error, reject(types.LOAD_2FA_QR)),
      }),
    ]);
  }
}

export function* remove2fa() {
  try {
    yield retry(4, 500, authClient?.Auth?.remove2fa);
    yield put({
      type: resolve(types.REMOVE_2FA),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types.REMOVE_2FA),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(error, reject(types.REMOVE_2FA)),
      }),
    ]);
  }
}
